import React from 'react';
import { IPrintCheckInfoDataSubmitValues } from './type';
import CheckUI from './CheckUI';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import shopSelectors from 'services/shop/selectors';
import { ESalaryPayrollType } from 'features/settingStaff/services/constants';
import { EHideFieldReport, isHideFieldReport } from 'utils/hide-field-report';
import Box from 'components/Box';
import StaffHistoryTimeClocks from '../Previews/StaffHistoryTimeClocks';
type Props = {
  value?: IPrintCheckInfoDataSubmitValues | null;
  printRef?: React.RefObject<HTMLDivElement>;
  manual?: boolean;
  className?: string;
};
const ReceiptPrinter = ({ value: data, printRef, manual, className }: Props) => {
  const printCheckSetting = shopSelectors.data.printCheckSetting();
  const listHideFieldReport = shopSelectors.getListHideFieldReport();

  return (
    <Container ref={printRef} className={className}>
      <div style={{ padding: '0 24px' }}>
        <CheckUI
          checkNum={data?.checkNo}
          date={data?.date.format('MM/DD/YYYY')}
          name={data?.staffName}
          amount={data?.totalCheck}
          signature={data?.signature}
          checkBank={data?.checkBank}
          forCheckNote={data?.forCheckNote}
          companyLogo={data?.companyLogo}
        />
      </div>
      <ReceiptInfo style={manual ? { display: 'none' } : { marginTop: '36px' }}>
        {isHideFieldReport(listHideFieldReport, EHideFieldReport.TOTAL_SALE) ? <></> : !!data?.totalSales && <Ticket>
          <span>TOTAL SALES</span>
          <span className="value">{formatCurrency(data?.totalSales)}</span>
        </Ticket>}
        {isHideFieldReport(listHideFieldReport, EHideFieldReport.SUPPLY_FEE) ? <></> : !!data?.supplyFee && <Ticket>
          <span>SUPPLY FEES</span>
          <span className="value">{formatCurrency(data?.supplyFee)}</span>
        </Ticket>}
        {isHideFieldReport(listHideFieldReport, EHideFieldReport.TOTAL) ? <></> : !!data?.total && <Ticket>
          <span>TOTAL</span>
          <span className="value">{formatCurrency(data?.total)}</span>
        </Ticket>}
        {isHideFieldReport(listHideFieldReport, EHideFieldReport.COMMISSION) ? <></> : !!data?.commission && <Ticket>
          <span>
            COMMISSION
            {!isHideFieldReport(
              listHideFieldReport,
              EHideFieldReport.PERCENT_COMMISSION
            ) && ` (${data?.commissionPercent || 0}%)`}
          </span>
          <span className="value">{formatCurrency(data?.commission)}</span>
        </Ticket>}
        {isHideFieldReport(listHideFieldReport, EHideFieldReport.TIP) ? <></> : !!data?.collectedTips && <Ticket>
          <span>COLLECTED TIPS</span>
          <span className="value">{formatCurrency(data?.collectedTips)}</span>
        </Ticket>}
        {!!data?.totalFeeCleaning && (
          <Ticket>
            <span>CLEANING FEE</span>
            <span className="value">-{formatCurrency(data?.totalFeeCleaning)}</span>
          </Ticket>
        )}
        {!!data?.supplyShareFee && (
          <Ticket>
            <span>SUPPLY SHARE</span>
            <span className="value">-{formatCurrency(data?.supplyShareFee)}</span>
          </Ticket>
        )}
        <div className="divider" />
        <Total>
          <span>TOTAL PAID OUT</span>
          <span className="value">{formatCurrency(data?.totalPaidOut)}</span>
        </Total>
        <Ticket>
          <span>BONUS ({data?.bonusPercent || 0}%)</span>
          <span className="value">{formatCurrency(data?.bonus)}</span>
        </Ticket>
        <Ticket>
          <span>CHECK ({data?.checkPercent || 0}%)</span>
          <span className="value">{formatCurrency(data?.check)}</span>
        </Ticket>
        <Ticket>
          <span>TIP TO BONUS ({data?.tipToBonusPercent || 0}%)</span>
          <span className="value">{formatCurrency(data?.tipToBonus)}</span>
        </Ticket>
        {!!data?.tipToCheck && (
          <Ticket>
            <span>TIP TO CHECK ({data?.tipCheckPercent || 0}%)</span>
            <span className="value">{formatCurrency(data?.tipToCheck)}</span>
          </Ticket>
        )}
        <div className="divider" />
        {data?.payrollType === ESalaryPayrollType.W2 && (
          <>
            <Total>
              <span>
                Federal Tax Withheld ({data?.tax?.federalTaxPercent || 0}%)
              </span>
              <span className="value">
                {formatCurrency(data?.tax?.federalTax)}
              </span>
            </Total>

            <Total>
              <span>
                Social Security Tax Withheld ({data?.tax?.socialTaxPercent || 0}%)
              </span>
              <span className="value">
                {formatCurrency(data?.tax?.socialTax)}
              </span>
            </Total>

            <Total>
              <span>
                Medicare Tax Withheld ({data?.tax?.medicalTaxPercent || 0}%)
              </span>
              <span className="value">
                {formatCurrency(data?.tax?.medicalTax)}
              </span>
            </Total>

            <div className="divider" />
          </>
        )}
        <Total>
          <span>TOTAL BONUS</span>
          <span className="value">
            {formatCurrency(data?.totalBonus)}
          </span>
        </Total>
        <Total>
          <span>TOTAL CHECK</span>
          <span className="value">
            {formatCurrency(data?.totalCheck)}
          </span>
        </Total>

      </ReceiptInfo>
      <Box style={manual ? { display: 'none' } : { height: '200px' }}>
        <StaffHistoryTimeClocksUI data={data?.historyTimeClocks}
          staffName={data?.staffName}
          tip={data?.collectedTips}
          totalPaidOut={data?.totalPaidOut}
          regularHours={data?.regularHours}
          regularPayAmount={data?.regularPayAmount}
          overtimeHours={data?.overtimeHours}
          overtimePayAmount={data?.overtimePayAmount}
          hideTimeClocks
        />
      </Box>
      <ReceiptInfo style={manual ? { display: 'none' } : {}}>
        <Ticket>
          <span>NOTE: {printCheckSetting?.note || '--'}</span>
        </Ticket>
      </ReceiptInfo>
    </Container>
  );
};

export default ReceiptPrinter;

const StaffHistoryTimeClocksUI = styled(StaffHistoryTimeClocks)`
  padding: 0 16px;
  .ReportPayrollCaption2Row .CAPTION_2 {
    color: black;
    font-family: Poppins;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 13px;
    text-transform: uppercase !important;
  }

  .ReportPayrollCaption2HighLightRow {
    background: unset !important;
    .CAPTION_2 {
      color: black !important;
      font-family: Poppins !important;
      font-size: 10px;
      font-style: normal;
      font-weight: 600;
      line-height: 13px;
    }
  }
`;

const Container = styled.div`
padding-top: 16px;
.page-break {
  margin: 16px;
}
`;
const Total = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  span {
    color: black;
    font-family: Poppins;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 13px;

    &.value {
      flex: 1;
      text-align: right;
    }
  }
`;
const Ticket = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  span {
    color: black;
    font-family: Poppins;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 13px;
    &.value {
      color: black;
      text-align: right;
    }
  }
`;
const ReceiptInfo = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0 16px;
margin-top: 60px;

.divider {
  background-color: black;
  height: 1px;
  width: 100%;
  align-self: stretch;
}
`;